import { render, staticRenderFns } from "./DialogActionForm.vue?vue&type=template&id=3bd8c314&scoped=true&"
import script from "./DialogActionForm.vue?vue&type=script&lang=js&"
export * from "./DialogActionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd8c314",
  null
  
)

export default component.exports